import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { useAdminParams } from 'utils/helpers';
import Cookies from 'js-cookie';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';

import c from '../utils/constants';
import subscription from '../transformers/subscriptionTransformer';

export default function useGetSubscription() {
  const { state } = useProvider();
  const { accountId } = useAdminParams();
  const {
    state: { isPreview },
  } = useAppWrapperContext();
  const args = state;
  const isAdmin = Cookies.get('_role') === 'admin';

  return useQuery({
    queryKey: [c.SUBSCRIPTION, accountId],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/subscriptions',
            transformer: subscription,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/subscriptions`,
            transformer: subscription,
          },
        }),
      );

      return data?.data;
    },
    enabled: !isAdmin || isPreview,
  });
}
